export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ./~/babel-preset-react-app/~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 749
// module chunks = 3